import React from "react";

const Achievement = () => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="achi-main">
                        <div className="title">ACHIEVEMENTS</div>
                        <div className="data-blocks-main">
                            <div className="data-block">
                                <div className="number">250+</div>
                                <div className="heading">DEALERS</div>
                            </div>
                            <div className="data-block">
                                <div className="number">2.5M+</div>
                                <div className="heading">ITEMS SOLD</div>
                            </div>
                            <div className="data-block">
                                <div className="number">3</div>
                                <div className="heading">CITIES</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Achievement;